export default "__VITE_ASSET__a4e5c96f__"